export type ISelectExternalSourceResult = (
  externalSourceId: number,
  json: string | IDCA.IExternalSource,
  pureJSON?: boolean,
  escaped?: boolean
) => void;

export function selectExternalSourceResult(
  externalSourceId: number,
  json: string | IDCA.IExternalSource,
  pureJSON = false,
  escaped = false
): void {
  const resultItem = pureJSON
    ? json
    : jQuery.parseJSON(`{${escaped ? decodeURIComponent(json as string) : json}}`);
  $.each(resultItem, (key: string, value) => {
    if (key.startsWith('field_')) {
      window.DexeroCoreApp.setFieldValue(key, value);
    }
  });

  $('#external-source-modal').modal('hide');
  $(`#modalExternalSourceContent${externalSourceId}`).modal('hide');
}
